import { IGoodsClassifierDTO, IGoodsClassifierViewDTO } from "../../coreapi-dto/dirs/goodsClassifier";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";


class GoodsClassifierRequest extends BaseDirRequest<IGoodsClassifierViewDTO, IGoodsClassifierDTO> {

    constructor(baseUrl:string, token:string, eventHandler: IRequestEventHandler){
        super(baseUrl, "Goods/Classifier", token, eventHandler)
    }

    create(body: IGoodsClassifierDTO, callback: (e: CoreApiResponse<string>) => void) {
       
        this.post<string>(`${this._baseUrl}/${this._routePrefix}/Create`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e: CoreApiResponse<string>) => {
                if (this._eventHandler) {
                    this._eventHandler.onGetResponse(e);
                }
                callback(e);
            }
        );
    }
    update(idGlobal: string, body: IGoodsClassifierDTO, callback: (e: CoreApiResponse<null>) => void): void {
        this.put(`${this._baseUrl}/${this._routePrefix}/${idGlobal}/Update`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }

    markDelete(idGlobal: string, callback: (e: CoreApiResponse<null>) => void) {
        this.delete(`${this._baseUrl}/${this._routePrefix}/${idGlobal}/Delete`, null, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                } else {
                    callback(e);
                }
            }
        })
    }

    restore(idGlobal: string, callback: (e: CoreApiResponse<null>) => void) {
        this.patch(`${this._baseUrl}/${this._routePrefix}/${idGlobal}/Restore`, null, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }
   

    batchCreate(body: IGoodsClassifierDTO[], callback: (e: CoreApiResponse<boolean>) => void) {
        this.post<boolean>(`${this._baseUrl}/${this._routePrefix}/BatchCreate`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }
}

export default GoodsClassifierRequest
